import { observable } from 'mobx';
import config from '../../../config';
import { session } from '../../Session';

export class SipStore {
    @observable private _sipStack?: SIPml.Stack;

    public get sipStack(): SIPml.Stack | undefined {
        return this._sipStack
    }

    public set sipStack(stack: SIPml.Stack | undefined) {
        this._sipStack = stack;
    }

    public start(
        onStackEvent: (e: SIPml.Stack.Event) => void,
        onError: (e: Error) => void
    ): void {
        if (session!.voipCredentials) {
            try {
                this._sipStack = new SIPml.Stack({
                    realm: session!.voipCredentials.server.realm,
                    impi: session!.voipCredentials.user.private_identity,
                    impu: session!.voipCredentials.user.public_identity,
                    password: session!.voipCredentials.user.password,
                    display_name: session!.user!.uuid,
                    websocket_proxy_url: session!.voipCredentials.server.websocket_url,
                    outbound_proxy_url: config.outbound_proxy_url,
                    enable_rtcweb_breaker: config.enable_rtcweb_breaker,
                    events_listener: { events: '*', listener: onStackEvent},
                    sip_headers: config.sip_headers
                });

                this._sipStack.start();
            } catch (e) {
                onError(e);
            }
        }
    }
}

export const sipStore = new SipStore();
